
import { Card, CardContent } from "@/components/ui/card";
import { Bell } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import NotificationItem from "@/components/NotificationItem";
import { Notification } from "@/context/NotificationContext";

interface NotificationsListProps {
  notifications: Notification[];
  onMarkAsRead: (id: string) => void;
  onDelete: (id: string) => void;
}

const NotificationsList = ({ 
  notifications,
  onMarkAsRead,
  onDelete
}: NotificationsListProps) => {
  const { toast } = useToast();

  const handleMarkAsRead = (id: string) => {
    onMarkAsRead(id);
    toast({
      title: "Notification marked as read",
    });
  };

  const handleDelete = (id: string) => {
    onDelete(id);
    toast({
      title: "Notification deleted",
      variant: "destructive",
    });
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Notifications</h2>
      {notifications.length === 0 ? (
        <Card>
          <CardContent className="pt-6 flex flex-col items-center justify-center py-10">
            <Bell className="h-12 w-12 text-muted-foreground mb-4" />
            <p className="text-muted-foreground">No notifications yet</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          {notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onMarkAsRead={handleMarkAsRead}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsList;
